import { z } from "zod";

export const ItemType = z.enum([
  "besoin",
  "idee",
  "risque",
  "decision",
  "action",
  "question",
  "temoignage",
  "autre",
]);
export type ItemType = z.infer<typeof ItemType>;

export const CaptureItemSchema = z.object({
  id: z.uuid(),
  captureId: z.uuid(),
  type: ItemType,
  text: z.string().min(1).max(5000),
  summary: z.string().min(1).max(1000).nullable(),
  speaker: z.string().min(1).max(120).nullable(),
  positionMs: z.number().int().nonnegative().nullable(),
  tags: z.array(z.string().min(1).max(50)).max(10).default([]),
  // Drapeaux qualité ajoutés au Lot 0.B (migration 20260520120000).
  // Les défauts (false) préservent l'invariance comportementale tant qu'aucun
  // code applicatif (Lots 7, 8, 10, 11) ne les peuple.
  needsReview: z.boolean().default(false),
  summaryFactualWarning: z.boolean().default(false),
  editedByHuman: z.boolean().default(false),
  notAnchored: z.boolean().default(false),
  // ADR 0018 : horodatage si l'item a été ajouté par la récupération auto des
  // éléments manqués (juge). Sert au badge « +N récupérés » côté UI.
  recoveredAt: z.iso.datetime().nullable().default(null),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type CaptureItem = z.infer<typeof CaptureItemSchema>;

export function parseCaptureItem(input: unknown): CaptureItem {
  return CaptureItemSchema.parse(input);
}
